import { useEffect } from "react";

export const CookiePolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#050505]" data-testid="cookie-policy-page">
      {/* Header */}
      <section className="py-16 md:py-24">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <p className="text-[0.625rem] tracking-[0.3em] uppercase text-[#D4AF37]/80 mb-4">
              Legal
            </p>
            <h1 className="text-3xl md:text-5xl tracking-[0.02em] text-white/90 mb-6" style={{ fontFamily: 'Cinzel, serif' }}>
              Cookie Policy
            </h1>
            <p className="text-white/40 text-sm">
              Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
            </p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="pb-24">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <div className="space-y-8 text-white/70 font-light leading-relaxed">
              
              <div>
                <h2 className="text-xl text-[#D4AF37] mb-4" style={{ fontFamily: 'Cinzel, serif' }}>1. What Are Cookies</h2>
                <p>
                  Cookies are small text files that are stored on your computer or mobile device when you visit our website. They help us provide you with a better browsing experience and allow certain features to function properly.
                </p>
              </div>

              <div>
                <h2 className="text-xl text-[#D4AF37] mb-4" style={{ fontFamily: 'Cinzel, serif' }}>2. Types of Cookies We Use</h2>
                
                <div className="space-y-4 mt-4">
                  <div className="p-4 bg-[#0A0A0A] border border-[#D4AF37]/20 rounded">
                    <h3 className="text-[#D4AF37] font-medium mb-2">Essential Cookies</h3>
                    <p className="text-sm">Required for the website to function properly. These cannot be disabled. They include cookies for security, session management, and basic functionality.</p>
                  </div>
                  
                  <div className="p-4 bg-[#0A0A0A] border border-[#D4AF37]/20 rounded">
                    <h3 className="text-[#D4AF37] font-medium mb-2">Performance Cookies</h3>
                    <p className="text-sm">Help us understand how visitors interact with our website by collecting anonymous information. This helps us improve our website's performance.</p>
                  </div>
                  
                  <div className="p-4 bg-[#0A0A0A] border border-[#D4AF37]/20 rounded">
                    <h3 className="text-[#D4AF37] font-medium mb-2">Functional Cookies</h3>
                    <p className="text-sm">Allow the website to remember choices you make (such as your region selection) and provide enhanced, personalized features.</p>
                  </div>
                  
                  <div className="p-4 bg-[#0A0A0A] border border-[#D4AF37]/20 rounded">
                    <h3 className="text-[#D4AF37] font-medium mb-2">Marketing Cookies</h3>
                    <p className="text-sm">Used to track visitors across websites to display relevant advertisements. These are set by third-party advertising partners.</p>
                  </div>
                </div>
              </div>

              <div>
                <h2 className="text-xl text-[#D4AF37] mb-4" style={{ fontFamily: 'Cinzel, serif' }}>3. Third-Party Cookies</h2>
                <p className="mb-4">
                  We may use third-party services that set their own cookies, including:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Google Analytics - for website analytics</li>
                  <li>Payment processors - for secure transactions</li>
                  <li>Social media platforms - for sharing functionality</li>
                  <li>Advertising partners - for relevant advertisements</li>
                </ul>
              </div>

              <div>
                <h2 className="text-xl text-[#D4AF37] mb-4" style={{ fontFamily: 'Cinzel, serif' }}>4. Managing Cookies</h2>
                <p className="mb-4">
                  You can control and manage cookies in several ways:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li><strong className="text-white/90">Browser Settings:</strong> Most browsers allow you to refuse or delete cookies through their settings.</li>
                  <li><strong className="text-white/90">Cookie Preferences:</strong> Use our cookie consent banner to manage your preferences.</li>
                  <li><strong className="text-white/90">Opt-Out Tools:</strong> Use industry opt-out tools for advertising cookies.</li>
                </ul>
                <p className="mt-4">
                  Please note that disabling certain cookies may affect the functionality of our website.
                </p>
              </div>

              <div>
                <h2 className="text-xl text-[#D4AF37] mb-4" style={{ fontFamily: 'Cinzel, serif' }}>5. Cookie Retention</h2>
                <p>
                  Cookies are retained for varying periods depending on their purpose. Session cookies are deleted when you close your browser, while persistent cookies may remain for months or years until they expire or you delete them.
                </p>
              </div>

              <div>
                <h2 className="text-xl text-[#D4AF37] mb-4" style={{ fontFamily: 'Cinzel, serif' }}>6. Updates to This Policy</h2>
                <p>
                  We may update this Cookie Policy from time to time to reflect changes in technology, legislation, or our data practices. We encourage you to review this policy periodically.
                </p>
              </div>

              <div>
                <h2 className="text-xl text-[#D4AF37] mb-4" style={{ fontFamily: 'Cinzel, serif' }}>7. Contact Us</h2>
                <p>
                  If you have questions about our use of cookies, please contact us at:
                </p>
                <p className="mt-4">
                  <strong className="text-[#D4AF37]">Goldnote Corporation</strong><br />
                  Email: privacy@goldnote.com<br />
                  Phone: 1-800-GOLDNOTE
                </p>
              </div>

            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CookiePolicy;
